export default {
	SET_PAGE(state, payload) {
		state.listing.page = payload
	}
}
